import * as React from "react";
import { useLocation } from "@grandvisionhq/frk-routing";
import { compose } from "@grandvisionhq/utils";
import { CmsContentBreadcrumbs } from "../../ContentBreadcrumbs/containers/Breadcrumbs/ContentBreadcrumbs/ContentBreadcrumbs.js";
import { withHidableContent } from "../../../../hocs/hocs/with-hidable-content.js";
const CmsBreadcrumbs = () => {
  const { pathname } = useLocation();
  return /* @__PURE__ */ React.createElement(CmsContentBreadcrumbs, { url: pathname });
};
const Breadcrumbs = compose(withHidableContent)(CmsBreadcrumbs);
export {
  CmsBreadcrumbs,
  Breadcrumbs as default
};
//# sourceMappingURL=Breadcrumbs.js.map
